import(/* webpackMode: "eager" */ "/opt/natoma/packages/frontend/src/app/(loggedin)/[tenant]/layout.tsx");
